export default "__VITE_ASSET__Cl$2$6ja__"